export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";

export const CREATE_CATEGORY_REQUEST = "CREATE_CATEGORY_REQUEST";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_FAILURE = "CREATE_CATEGORY_FAILURE";

export const UPDATE_CATEGORY_REQUEST = "UPDATE_CATEGORY_REQUEST";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAILURE = "UPDATE_CATEGORY_FAILURE";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAILURE = "DELETE_CATEGORY_FAILURE";

export const GET_CATEGORIES_WITH_PAGINATION_REQUEST =
  "GET_CATEGORIES_WITH_PAGINATION_REQUEST";
export const GET_CATEGORIES_WITH_PAGINATION_SUCCESS =
  "GET_CATEGORIES_WITH_PAGINATION_SUCCESS";
export const GET_CATEGORIES_WITH_PAGINATION_FAILURE =
  "GET_CATEGORIES_WITH_PAGINATION_FAILURE";

  
export const UPLOAD_EXCEL_CATEGORY_REQUEST = "UPLOAD_EXCEL_CATEGORY_REQUEST";
export const UPLOAD_EXCEL_CATEGORY_SUCCESS = "UPLOAD_EXCEL_CATEGORY_SUCCESS";
export const UPLOAD_EXCEL_CATEGORY_FAILURE = "UPLOAD_EXCEL_CATEGORY_FAILURE";

export const DOWNLOAD_CATEGORY_CREATION_REQUEST = "DOWNLOAD_CATEGORY_CREATION_REQUEST";
export const DOWNLOAD_CATEGORY_CREATION_SUCCESS = "DOWNLOAD_CATEGORY_CREATION_SUCCESS";
export const DOWNLOAD_CATEGORY_CREATION_FAILURE = "DOWNLOAD_CATEGORY_CREATION_FAILURE";
